import { bindActionCreators } from "@reduxjs/toolkit";
import { store } from "../app/store";
import {
  resetFilters,
  setActiveStep,
  setFrontendBoot,
  setInsurers,
  setLeadData,
  setPlanType,
  setSortBy,
  setSumInsurer,
  setTraceId,
  setUuid,
  setBlockTata,
  setDisableMembers,
} from "./input.slice";
import {
  setActive,
  setCKycFailCount,
  setCKycResponse,
  setCKycStatus,
  setCKycUploadLoader,
  setCKycUploadStatus,
  setMetaData,
  setPrimaryProposerId,
  setProposalData,
  setProposalMembers,
  setTAndCAgree,
  resetCkycUploadStatus,
} from "./proposal.slice";
import {
  addQuoteToShortlist,
  clearCompareQuote,
  removeQuoteFromCompare,
  setCompareQuote,
  setEditMode,
  setInsurerOpen,
  setKnowMoreData,
  setPlanName,
  setQuotesToShare,
  setShareSelectedQuotes,
  setShowAddCompareModal,
  setShowCompareModal,
  setShowDifference,
  setShowEdit,
  setShowSortBy,
  setShowSumInsurer,
  toggleMoreQuotes,
  toggleShareQuotes,
} from "./quote.slice";

const bindActions = () =>
  bindActionCreators(
    {
      resetFilters,
      setActiveStep,
      setFrontendBoot,
      setInsurers,
      setLeadData,
      setPlanType,
      setSortBy,
      setSumInsurer,
      setTraceId,
      setBlockTata,
      setDisableMembers,
      setUuid,
      setActive,
      setCKycFailCount,
      setCKycResponse,
      setCKycStatus,
      setCKycUploadLoader,
      setCKycUploadStatus,
      setMetaData,
      setTAndCAgree,
      setPrimaryProposerId,
      setProposalData,
      setProposalMembers,
      addQuoteToShortlist,
      clearCompareQuote,
      toggleShareQuotes,
      toggleMoreQuotes,
      removeQuoteFromCompare,
      setCompareQuote,
      setEditMode,
      setShowEdit,
   
      setInsurerOpen,
      setKnowMoreData,
      setPlanName,
      setQuotesToShare,
      setShareSelectedQuotes,
      setShowAddCompareModal,
      setShowCompareModal,
      setShowDifference,
      setShowSortBy,
      setShowSumInsurer,
      resetCkycUploadStatus,
    },
    store.dispatch
  );
export const Actions = bindActions();
